import S from 's-js';

import { BerthReservation } from 'data/models/BerthReservation';
import { Measurement } from 'data/models/Measurement';

export class EndMark extends Measurement {
    constructor(reservation : BerthReservation) {
        super();

        this.Num = function (v? : number) {
            if (v === undefined) {
                return reservation.Footmark.add(reservation.Length).Num();
            } else {
                const newFootmark = S.sample(() =>
                    new Measurement({ Num: v, UOM: reservation.Footmark.UOM() })
                        .subtract(reservation.Length)
                        .Num()
                );
                reservation.Footmark.Num(newFootmark);
                return v;
            }
        };

        this.UOM = () => reservation.Footmark.UOM();
    }
}



// WEBPACK FOOTER //
// ./data/models/EndMark.ts